export default __webpack_public_path__ + "static/media/pay-advice-blue-icon.82ba29f9.svg";